import '../styles/components/shop.css'
import { getProducts } from '../lib/supabase.js'
import { createProductCard } from '../components/product-card.js'
import { updateMeta, injectJsonLd, clearJsonLd } from '../utils/seo.js'
import { store } from '../store.js'

let currentCategory = 'all'
let allProducts = []

export async function renderShop(outlet) {
  clearJsonLd()
  updateMeta({
    title: 'Shop Carbon Fiber Knife Sharpening Platens | Airplaten',
    description: 'Browse carbon fiber platens for belt grinders. Flat and radius platens for knife sharpening, blade grinding, and metalworking. Fits 2x42, 2x36, Bucktool.',
    canonicalPath: '/#/shop',
  })

  outlet.innerHTML = `
    <div class="shop-page">
      <div class="container">
        <div class="shop-header">
          <div class="section-eyebrow">All Products</div>
          <h1 class="section-title" style="text-align:left">Shop Airplaten</h1>
        </div>

        <div class="shop-filters" id="shop-filters"></div>

        <div id="products-grid" class="products-grid">
          <div class="products-loading">
            <div class="spinner"></div>
            <span>Loading products…</span>
          </div>
        </div>
      </div>
    </div>
  `

  // Filter buttons
  document.getElementById('shop-filters')?.addEventListener('click', (e) => {
    const btn = e.target.closest('.filter-btn')
    if (!btn) return
    currentCategory = btn.dataset.category
    document.querySelectorAll('.filter-btn').forEach(b => {
      b.classList.toggle('active', b.dataset.category === currentCategory)
    })
    renderProducts(currentCategory)
  })

  await loadProducts()
}

async function loadProducts() {
  try {
    allProducts = await getProducts()
    store.refreshCartImages(allProducts)

    // Inject ItemList JSON-LD
    if (allProducts.length > 0) {
      injectJsonLd({
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        'name': 'Carbon Fiber Platens for Belt Grinders',
        'itemListElement': allProducts.map((p, i) => ({
          '@type': 'ListItem',
          'position': i + 1,
          'url': p.slug ? `https://www.airplaten.com/products/${p.slug}` : `https://www.airplaten.com/#/product/${p.id}`,
          'name': p.name,
        })),
      }, 'itemlist')
    }

    // Build category filters from actual product data
    const cats = [...new Set(allProducts.map(p => p.category).filter(Boolean))]
    const filtersEl = document.getElementById('shop-filters')
    if (filtersEl) {
      filtersEl.innerHTML = [
        `<button class="filter-btn active" data-category="all">All Products</button>`,
        ...cats.map(c => `<button class="filter-btn" data-category="${c}">${c}</button>`),
      ].join('')
    }

    renderProducts(currentCategory)
  } catch (err) {
    console.error('[shop] Failed to load products:', err)
    const grid = document.getElementById('products-grid')
    if (grid) grid.innerHTML = '<p class="products-empty text-secondary">Unable to load products. Please try again.</p>'
  }
}

function renderProducts(category) {
  const grid = document.getElementById('products-grid')
  if (!grid) return

  const filtered = category === 'all'
    ? allProducts
    : allProducts.filter(p => p.category === category)

  grid.innerHTML = ''

  if (filtered.length === 0) {
    grid.innerHTML = `<p class="products-empty text-secondary">No products in this category yet.</p>`
    return
  }

  filtered.forEach(p => grid.appendChild(createProductCard(p)))
}
